import { configureStore } from "@reduxjs/toolkit";
import SessionReducer from "./Session";
import UIReducer from "./UI";
import AppReducer from "./App";

export const store = configureStore({
  reducer: {
    session: SessionReducer,
    ui: UIReducer,
    app: AppReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;